import { render, staticRenderFns } from "./VCircle.vue?vue&type=template&id=60142536&scoped=true&lang=pug&"
import script from "./VCircle.vue?vue&type=script&lang=js&"
export * from "./VCircle.vue?vue&type=script&lang=js&"
import style0 from "./VCircle.vue?vue&type=style&index=0&id=60142536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60142536",
  null
  
)

export default component.exports